import '../assets/styles/aboutUs.css'

export default function AboutUs() {
    return (
        <div>
            <div className="about-us">
                <div className="about-us-container">
                    <div className="about-us-left">
                        <img className='about-us-image' src="https://images.unsplash.com/photo-1663946179345-41483ed01b41?q=80&w=3086&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="studio" />
                    </div>
                    <div className="about-us-right">
                        <div className="about-us-sub">
                            <h2>our story</h2>
                            <p>ty-me</p>
                        </div>
                        <div className="about-us-title">
                        <p className="banner-title-name">Crafting Art with Precision</p>
                        <p className="banner-title-subname">Chennai’s Premier Tattoo Experience</p>
                        </div>
                        <p className="about-us-description">At Tyme Tattoos, we don’t just create designs; we curate experiences. Our approach is centered on discovering and capturing the essence of what you want, making your first tattooing journey truly unforgettable. This dedication to personal connection and artistic excellence is the cornerstone of why our clients return and recommend us. Trust in our expertise and let us bring your vision to life with the artistry it deserves.</p>
                        <div className="about-us-btn-container">
                            <button className="about-us-btn">Read More</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}